var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#B9B9B9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1896_1274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1896_1274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.998 30.0002C21.448 30.0002 20.9772 29.8044 20.5855 29.4127C20.1939 29.0211 19.998 28.5502 19.998 28.0002C19.998 27.4502 20.1939 26.9794 20.5855 26.5877C20.9772 26.1961 21.448 26.0002 21.998 26.0002C22.548 26.0002 23.0189 26.1961 23.4105 26.5877C23.8022 26.9794 23.998 27.4502 23.998 28.0002C23.998 28.5502 23.8022 29.0211 23.4105 29.4127C23.0189 29.8044 22.548 30.0002 21.998 30.0002ZM21.998 24.0002C21.448 24.0002 20.9772 23.8044 20.5855 23.4127C20.1939 23.0211 19.998 22.5502 19.998 22.0002C19.998 21.4502 20.1939 20.9794 20.5855 20.5877C20.9772 20.1961 21.448 20.0002 21.998 20.0002C22.548 20.0002 23.0189 20.1961 23.4105 20.5877C23.8022 20.9794 23.998 21.4502 23.998 22.0002C23.998 22.5502 23.8022 23.0211 23.4105 23.4127C23.0189 23.8044 22.548 24.0002 21.998 24.0002ZM21.998 18.0002C21.448 18.0002 20.9772 17.8044 20.5855 17.4127C20.1939 17.0211 19.998 16.5502 19.998 16.0002C19.998 15.4502 20.1939 14.9794 20.5855 14.5877C20.9772 14.1961 21.448 14.0002 21.998 14.0002C22.548 14.0002 23.0189 14.1961 23.4105 14.5877C23.8022 14.9794 23.998 15.4502 23.998 16.0002C23.998 16.5502 23.8022 17.0211 23.4105 17.4127C23.0189 17.8044 22.548 18.0002 21.998 18.0002Z",
    fill: "#5C5C5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMore);
export default __webpack_public_path__ + "static/media/ic_more.f11d2a16298f5d52aac612a2f516d222.svg";
export { ForwardRef as ReactComponent };